angular.module('jv.Admin.Users')
    .factory('modalObjectTemplateFAC', [function () {
        return {
            get: function(typeObject) {
                return {
                    type: typeObject.name.toUpperCase(),
                    show: true,
                    headText: typeObject.title,
                    showCC: false,
                    showBCC: false,
                    showLinks: false,
                    templates: [],
                    templatePlaceHolder: typeObject.placeholder,
                    subjectPlaceHolder: typeObject.subjectPlaceholder
                };
            },
            setDefault: function(templates) {
                var selectedTemplate = {};
                angular.forEach(templates, function(templt){
                    if(templt['default']){
                        selectedTemplate.template = templt;
                        selectedTemplate.subject = templt.subject;
                        selectedTemplate.body = templt.body;
                    }
                });
                return selectedTemplate;
            }
        };
    }])
    .controller('jvAdminUsersEmplyeeListController',
        ['$scope', 'adminUserSVC', '$rootScope', '$location', '$route', 'breadcrumbsResolve', 'enumToValueMap', 'commonListActionsFAC', '$timeout', 'modalObjectTemplateFAC', 'jvAdminUsersRolesService',
            function($scope, adminUserSVC, $rootScope, $location, $route, breadcrumbsResolve, enumToValueMap, commonListActionsFAC, $timeout, modalObjectTemplateFAC, jvAdminUsersRolesService) {

                $scope.flags.loading = false;
                $scope.flags.expanded = true;
                var isPaginate = false;  //This variable will be toggled to get list on first page for any change in filter/sort which trigger employee search
                $scope.employeeSelect = adminUserSVC.employeeSelect;
                $scope.allLocations = []; //to store all locations irrespective of regions. list will be rendered in location filter on load
                $scope.filters = {};
                $scope.reqList = {};
                $scope.selectedEmployee = [];// model will be set from gridlist when particular user is selected (EId's only)
                $scope.selectedRows = []; //
                $scope.messageModal = {};
                $scope.roleModal = {};
                $scope.ownerIds = [];
                $scope.hiringManagerIds = [];
                $scope.recruiterIds = [];
                $scope.importModal = {
                    show: false,
                    disableUpload: true,
                    uploadedFile:{}
                };
                //get employee data modal
                $scope.showEmployeeDataModal = false;
                $scope.employeeListDetails = {};
                $scope.showMsg($scope.params.message);

                $scope.oldEmployeeSyncURL = jvUrls.forum + 'HR/SynchronizeEmployees2.aspx';
                // Breadcrumb Config Array
                $scope.breadcrumbsConfig = breadcrumbsResolve;

                // Sort options
                $scope.sortListConfig = {
                    sortOptions: [
                        {
                            value: i18n['FIRST_NAME'],
                            id: 'FirstName'
                        },
                        {
                            value: i18n['LAST_NAME'],
                            id: 'LastName'
                        },
                        {
                            value: i18n['EMAIL'],
                            id: 'Email'
                        },
                        {
                            value: i18n['INVITE_STATUS'],
                            id: 'InviteStatus'
                        },
                        {
                            value: i18n['CREATED_DATE'],
                            id: 'CreatedDate'
                        }
                    ],
                    sortOrder: [
                        {
                            value: i18n['ASCENDING'],
                            id: 'asc'
                        },
                        {
                            value: i18n['DESCENDING'],
                            id: 'desc'
                        }],
                    selectedOption: 0,
                    selectedSortOrder: 0
                };

                $scope.actionListConfig = {
                    actionTitle: 'Actions',
                    sortOptions: [
                        {
                            value: i18n['SEND_INVITE'],
                            id: 0
                        },
                        {
                            value: i18n['SEND_NOTE'],
                            id: 1
                        },
                        {
                            value: i18n['LOCK_RECORDS'],
                            id: 2
                        },
                        {
                            value: i18n['UNLOCK_RECORDS'],
                            id: 3
                        },
                        {
                            value: i18n['ADD_ROLES'],
                            id: 4
                        },
                        {
                            value: i18n['REMOVE'],
                            id: 5
                        }
                    ],
                    selectedOption: -1
                };

                $scope.actionListBottomConfig = angular.copy($scope.actionListConfig);

                $scope.$watch('actionListConfig.selectedOption', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && newValue != -1) {
                        triggerAction(newValue, $scope.actionListConfig);
                        $scope.actionListConfig.selectedOption  = -1;
                    }
                });

                $scope.$watch('actionListBottomConfig.selectedOption', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && newValue != -1) {
                        triggerAction(newValue, $scope.actionListBottomConfig);
                        $scope.actionListBottomConfig.selectedOption = -1;
                    }
                });

                var triggerAction = function(index, sourceList){
                    var selectedActionId = sourceList.sortOptions[index].id;
                    if($scope.change(selectedActionId, sourceList) === -1) {
                        sourceList.message = i18n['NO_EMP_SELECTED'];
                        sourceList.selectedOption = -1;
                    }
                };

               // Watching sortListConfig for selected option
                $scope.$watch('sortListConfig.selectedOption', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && $scope.filters && $scope.filters.sortBy) {
                        $scope.filters.sortBy = $scope.sortListConfig.sortOptions[newValue].id;
                    }
                });

                // Watching sortListConfig for selected sort order
                $scope.$watch('sortListConfig.selectedSortOrder', function(newValue, oldValue) {
                    if (angular.isDefined(newValue) && $scope.filters && $scope.filters.order) {
                        $scope.filters.order = $scope.sortListConfig.sortOrder[newValue].id;
                    }
                });

                $scope.checkAll = false;
                $scope.defaultFilters = {
                    q: '',
                    sortBy: 'FirstName',
                    order: 'asc',
                    subsidiaryIds: '',
                    departmentIds: '',
                    roles:[],
                    rolesObject: [],
                    inviteStatus:'',
                    regionIds: '',
                    locationIds: '',
                    pageSize: 0,
                    page: 0
                };
                $scope.defaulModalFilters = {
                    maxModalResults: 10,
                    modalPage: 0
                };
                $scope.map = enumToValueMap;
                
                $scope.openImportModal = function() {
                	$rootScope.$broadcast('showImportEmployeeModal', "employee");
                };
                
                var refreshListPage = $rootScope.$on('refreshListPage', function(event, data) {
                	$scope.searchEmployees(true);
                });
                
                $scope.downloadTemplate = function() {
                	adminUserSVC.downloadTemplate();
                }

                var importedEmployeeSyncFile = $rootScope.$on('importedEmployeeSyncFile', function(event, data) {
                	if(data && data.uploadedFile && data.uploadedFile.employeeSyncKey && data.uploadedFile.fileName){
                		$scope.flags.loading=true;
                    	var sendInviteEmail = (data.sendInviteEmail) ? data.sendInviteEmail : false;
                        var fullSync = data.fullSync;
                        var resetSync = data.resetSync;
                        var considerExclusionList = data.considerExclusionList;
                        var key = data.uploadedFile.employeeSyncKey;
                        var fileName = data.uploadedFile.fileName;
                        var fileDelimiter = data.fileDelimiter;
                        $scope.fileName = data.uploadedFile.fileName;
                    	adminUserSVC.import(key, fileName, sendInviteEmail, fullSync, resetSync, considerExclusionList, fileDelimiter, function(response){
                    		$scope.flags.loading=false;
                    		$rootScope.$broadcast('showImportEmployeeConfirmationModal', response);
                    	});
                	}
                });
                
                $scope.getEmployeeListFilters = function() {
                    adminUserSVC.getEmployeeListDetails(function(response) {
                        $scope.initializeFilters(response);
                    });
                };

                $scope.initializeFilters = function(data) {
                    // Assigning response to model which will render all filter values in respective controls
                    $scope.employeeListDetails = angular.copy(data);
// TODO: Remove after back-end changes are done                   
//                    $scope.employeeListDetails.filters.cityNames = $scope.employeeListDetails.filters.inviteStatus;
//                    $scope.employeeListDetails.filters.cityNames[0].value="City0";
//                    $scope.employeeListDetails.filters.cityNames[1].value="City1";
//                    $scope.employeeListDetails.filters.cityNames[2].value="City2";
//                    
//                    $scope.employeeListDetails.filters.countryNames = $scope.employeeListDetails.filters.inviteStatus;
//                    $scope.employeeListDetails.filters.countryNames[0].value="Country0";
//                    $scope.employeeListDetails.filters.countryNames[1].value="Country1";
//                    $scope.employeeListDetails.filters.countryNames[2].value="Country2";
//                    
//                    $scope.employeeListDetails.filters.stateNames = $scope.employeeListDetails.filters.inviteStatus;
//                    $scope.employeeListDetails.filters.stateNames[0].value="State0";
//                    $scope.employeeListDetails.filters.stateNames[1].value="State1";
//                    $scope.employeeListDetails.filters.stateNames[2].value="State2";
                    	
                    $scope.defaultFilters.pageSize = $scope.employeeListDetails.pageSize;
                    $scope.modalFilters = angular.copy($scope.defaulModalFilters)
                    // Initialize department/subsidiary/location maps, this help us read respective EId/Name pair for each employee, as search returns only EId and FE needs to resolve the name
                    angular.forEach($scope.employeeListDetails.filters.subsidiaries, function(subsidiary) {
                        $scope.map.subsidiaries[subsidiary.EId] = subsidiary.name;
                    });
                    angular.forEach($scope.employeeListDetails.filters.departments, function(dept) {
                        $scope.map.departments[dept.EId] = dept.name;
                    });
                    
                    $scope.employeeListDetails.filters.selectedLocations = [];
                    angular.forEach($scope.employeeListDetails.filters.locations, function(loct) {
                        if(angular.isArray(loct.value)) {
                            angular.forEach(loct.value,function(loc) {
                                $scope.map.locations[loc.EId] = loc.name;//location map
                                $scope.employeeListDetails.filters.selectedLocations.push(loc);// this is to show all locations in dropdown by default
                            });
                        }
                    });
                    // copied to new variable. We need this list when user resets filters
                    $scope.allLocations = angular.copy($scope.employeeListDetails.filters.selectedLocations);
                    //initialize search filters with default filters to trigger the 'FILTER' watch and fetch result.
                    
                    //If landing on the employee list page to filter by role code, fetch the role details 
                    //so that the page can be filtered based on the role code. 
                    //Example: http://local.corp.jobvite.com/admin/config/users/index.html#/users/employees/ROLE_HIRING_MANAGER
                    if ($scope.params.roleCode) {
                        var queryData = {
                            page: 0,
                            roleCodes: $scope.params.roleCode
                        };
                        jvAdminUsersRolesService.getRoles(queryData, function(response) {
                            if (response && response.roles) {
                                $scope.defaultFilters.rolesObject.push(response.roles[0]);
                            }
                            $scope.filters = angular.copy($scope.defaultFilters);
                        });
                    } else {
                        $scope.filters = angular.copy($scope.defaultFilters);
                    }



                    //Initialize action dropdown
                    if($scope.employeeListDetails.disableLockUnlock && !$scope.actionListConfig.disableLockUnlock) {
                        $scope.actionListConfig.sortOptions.splice(2,2);
                        $scope.actionListConfig.disableLockUnlock = true;
                    }
                    $scope.actionListBottomConfig = angular.copy($scope.actionListConfig);
                };

                //will be called to populate locations for selected region
                $scope.selectLocations= function(region){
                    if(region){
                        $scope.employeeListDetails.filters.selectedLocations=[];
                        angular.forEach($scope.employeeListDetails.filters.locations, function(location, index){
                            if(location.key== region)
                                $scope.employeeListDetails.filters.selectedLocations=location.value;
                        });
                    }else{
                        $scope.employeeListDetails.filters.selectedLocations=angular.copy($scope.allLocations);
                    }
                };

                $scope.getEmployeeListFilters();
                //watching this variable for search/filter and sort actions
                $scope.$watch("filters",function(newVal, oldVal){
                    if(newVal && angular.isArray(newVal.roles)){
                        if(!isPaginate){
                            $scope.filters.page=0;
                        }
                        $scope.searchEmployees();
                    }
                },true);

                $scope.initiateDateSearch = function(newVal, oldVal) {
                	if(newVal && newVal !== oldVal || (newVal === "" && oldVal)){
                        if(!isPaginate){
                            $scope.filters.page=0;
                        }
                        $scope.searchEmployees();
                    }
                };
                
                $scope.$watch("startDateFrom",function(newVal, oldVal){
                	$scope.initiateDateSearch(newVal, oldVal);
                },true);
                
                $scope.$watch("startDateTo",function(newVal, oldVal){
                	$scope.initiateDateSearch(newVal, oldVal);
                },true);
                
                $scope.searchEmployees = function(isFastRead){
                    $scope.flags.loading = true;
                    $scope.checkAll = false;
                    $scope.selectedEmployee = [];
                    var readMode = false;
                    if(isFastRead || ($scope.urlParams().readMode === 0)){
                        readMode = true;
                    }
                    var postParams = angular.copy($scope.filters);
                    
                    //Only if rolesObject which will be populated by custom roles, then send role code
                    //for the employee search query. 
                    if (angular.isArray(postParams.rolesObject) && postParams.rolesObject.length > 0) {
                        var roleArray = [];
                        angular.forEach(postParams.rolesObject, function(roleObject, key){
                            roleArray.push(roleObject.code);
                        });
                        postParams.roles = roleArray;
                        delete postParams.rolesObject;
                    }

                    if(postParams.accessGroupsObject) {
                        var accessGroupIdsArray = [];
                        angular.forEach(postParams.accessGroupsObject, function(obj) {
                            var accessGroupId = obj.id;
                            accessGroupIdsArray.push(accessGroupId);
                        });
                        postParams.accessGroupIds = accessGroupIdsArray;
                        delete postParams.accessGroupsObject;
                    }

                    if($scope.startDateFrom && $scope.startDateFrom.trim() !== "") {
                    	postParams.startDateFrom = $scope.startDateFrom;
                    }
                    if($scope.startDateTo && $scope.startDateTo.trim() !== "") {
                    	postParams.startDateTo = $scope.startDateTo;
                    }
                    if(postParams.locked == undefined)
                        delete postParams.locked;
                    if(postParams.inviteStatus == 10) {
                        postParams.inviteStatus = [1,3];
                    }
                    commonListActionsFAC.sortByRelevance($scope.filters, $scope.sortListConfig, i18n.RELEVANCE);
                    //Pass current selected filter as search parameters
                    adminUserSVC.searchEmployees(postParams, function(response){
                        $scope.employeeList = response.employees;
                        $scope.employeeCount = response.count;
                        //Formatting search, initialize properties as '-' to display it by default
                        if($scope.employeeListDetails && $scope.employeeListDetails.displayFields){
                            angular.forEach($scope.employeeList,function(employee){
                                employee.subsidiary = employee.subsidiaryEId? $scope.map.subsidiaries[employee.subsidiaryEId]:'-';
                                employee.department = employee.departmentEId? $scope.map.departments[employee.departmentEId]: '-';
                                employee.location = employee.locationEId? $scope.map.locations[employee.locationEId]: '-';
                            });
                        }
                        $scope.flags.loading = false;
                        isPaginate = isPaginate?false:true;
                    },readMode);
                };

                //Employee list pagination
                $scope.recordsEnd = function() {
                    if ($scope.filters) {
                        return Math.min($scope.filters.pageSize * ($scope.filters.page + 1), $scope.employeeCount);
                    }
                };
                $scope.recordsStart = function() {
                    if ($scope.filters) {
                        return $scope.filters.pageSize * $scope.filters.page + 1;
                    }
                };
                $scope.next = function() {
                    if ($scope.filters.page < $scope.employeeCount / $scope.filters.pageSize - 1) {
                        isPaginate=true;
                        $scope.filters.page++;
                    }
                };
                $scope.prev = function() {
                    if ($scope.filters.page !== 0) {
                        isPaginate= true;
                        $scope.filters.page--;
                    }
                };

                //Requisitions modal pagination
                $scope.modalRecordsEnd = function() {
                    if ($scope.modalFilters) {
                        return Math.min($scope.modalFilters.maxModalResults * ($scope.modalFilters.modalPage + 1), $scope.totalCount);
                    }
                };
                $scope.modalRecordsStart = function() {
                    if ($scope.modalFilters) {
                        return $scope.modalFilters.maxModalResults * $scope.modalFilters.modalPage + 1;
                    }
                };
                $scope.modalNext = function() {
                    if ($scope.modalFilters.modalPage < $scope.totalCount / $scope.modalFilters.maxModalResults - 1) {
                        isPaginate=true;
                        $scope.modalFilters.modalPage++;
                    }
                    if(!isPaginate){
                        $scope.modalFilters.modalPage=0;
                    }
                    $scope.showReqList(null,$scope.modalFilters.modalPage,null,false);
                };
                $scope.modalPrev = function() {
                    if ($scope.modalFilters.modalPage !== 0) {
                        isPaginate= true;
                        $scope.modalFilters.modalPage--;
                    }
                    if(!isPaginate){
                        $scope.modalFilters.modalPage=0;
                    }
                    $scope.showReqList(null,$scope.modalFilters.modalPage,null,false);
                };
                $scope.search = function(key){
                    $scope.filters.q = key;
                    $scope.filters.sortBy = key?'Relevance': $scope.defaultFilters.sortBy;
                };

                $scope.resetSearch = function(){
                    var filterOptions = angular.copy($scope.employeeListDetails);
                    $scope.employeeListDetails ={};
                    $scope.selectedEmployee = [];
                    $scope.checkAll = false;
                    $scope.sortListConfig.selectedOption = 0;
                    $scope.sortListConfig.selectedSortOrder = 0;
                    $scope.initializeFilters(filterOptions);
                    $scope.startDateTo = "";
                    $scope.startDateFrom = "";
                };

                //Called UC: selecting employees from list and Clicking 'Update Role' from Actions
                $scope.showUpdateRoles = function() {
                    //getSelectedEmployees();
                    if ($scope.selectedRows.length == 1) {
                        $scope.showUpdateRoleModal($scope.selectedRows[0].roles, $scope.selectedRows[0]);
                    } else if ($scope.selectedRows.length > 0) {
                        var empRoles;
                        var currentemp;
                        angular.forEach($scope.selectedRows, function(value, index) {
                            if (value && value.EId === _jvselfUser.eid) {
                                empRoles = value.roles;
                                currentemp = value;
                            }
                        });
                        if (currentemp && empRoles) {
                            $scope.showUpdateRoleModal(empRoles, currentemp);
                        } else {
                            $scope.showUpdateRoleModal();
                        }
                    }
                };

                //function to create object for all selected employees in grid list
                var getSelectedEmployees = function(){
                    $scope.selectedRows = [];
                    angular.forEach($scope.selectedEmployee, function(value,index){
                        if(value){
                            $scope.selectedRows.push($scope.employeeList[index]);
                        }
                    });
                };

                //This will be called by clicking roles in Employee grid list
                $scope.showUpdateRoleModal = function(roles, employee) {
                    $scope.roleModal = {};
                    $scope.roleModal.rolesList = angular.copy($scope.employeeListDetails.rolesDetails);
                    $scope.roleModal.errorRoleName = $scope.employeeListDetails.isHireExpress ? i18n['ROLE_RECRUITER'] : i18n['ROLE_RESEARCHER'];

                    $scope.roleModal.selectedEmpCount = $scope.selectedEmployee.length;
                    if (employee) {
                        $scope.selectedRows = [];
                        $scope.selectedRows.push(employee);
                    }

                    $scope.selectedUserEId = null;

                    if ($scope.selectedRows.length === 1) {
                        $scope.selectedUserEId = $scope.selectedRows[0].EId;
                    }

                    if ($scope.roleModal.rolesList) {
                        angular.forEach($scope.roleModal.rolesList, function(role) {
                            if (role.key === 'ROLE_EMPLOYEE') {
                                role.checked = true;
                                role.disable = true;
                            }
                            if (role.key === 'ROLE_JOBAPPROVER' && $scope.employeeListDetails.isApprovalDisabled) {
                                role.disable = true;
                            }

                            //Change to block the current user to add higher roles like SuperUser and Administrator to self
                            if (employee && employee.EId === _jvselfUser.eid && (role.key === 'ROLE_SUPERUSER' || role.key === 'ROLE_ADMINISTRATOR')) {
                                role.disable = true;
                            }

                            angular.forEach(roles, function(empRole) {
                                if (empRole.key === role.key) {
                                    role.checked = true;
                                    role.isPresent = true;
                                    $scope.cascadeRoleSelect(role);
                                    $scope.roleModal.selectedRolesCount++;
                                }
                            });
                        });
                    }

                    if (employee && employee.usrRoles) {
                        $scope.roleModal.usrRoles = employee.usrRoles;

                    }
                    $scope.roleModal.show = true;
                };

                //Update employee roles post to BE
                $scope.updateRoles = function(){
                    $scope.flags.loading = true;
                    var isRecruiter = false,isHiringManager = false;
                    $scope.ownerIds = [];
                    var postParams = {};
                    $scope.reqList.updateParams={};
                    postParams['userIds'] = [];
                    postParams['updateRole'] = [];
                    postParams['addRole'] = [];

                    //Changes for custom Roles and simplifying it.
                    if ($scope.roleModal.usrRoles) {
                        if ($scope.selectedRows && $scope.selectedRows.length) {
                            //Update Role Usecase
                            if ($scope.selectedRows.length == 1) {
                                postParams['userIds'].push($scope.selectedRows[0].EId);
                                if ($scope.selectedRows[0].usrRoles) {
                                    angular.forEach($scope.selectedRows[0].usrRoles, function(usrRole) {
                                        if (usrRole.type === 'Recruiter') {
                                            isRecruiter = true;
                                        }
                                        if (usrRole.type === 'HiringManager') {
                                            isHiringManager = true;
                                        }
                                    });
                                }
                                angular.forEach($scope.roleModal.usrRoles, function(role) {
                                    postParams['updateRole'].push(role.code);
                                    if (role.type === 'Recruiter') {
                                        isRecruiter = false;
                                    }
                                    if (role.type === 'HiringManager') {
                                        isHiringManager = false;
                                    }
                                });
                            } else {
                            //Add Role Usecase
                                angular.forEach($scope.selectedRows, function(employee) {
                                    postParams['userIds'].push(employee.EId);
                                });
                                angular.forEach($scope.roleModal.usrRoles, function(role) {
                                    postParams['addRole'].push(role.code);
                                });
                            }
                            if (isRecruiter || isHiringManager) {
                                $scope.ownerIds.push($scope.selectedRows[0].EId);
                                $scope.reqList.showRoleUpdate = true;
                                $scope.reqList.showRemove = false;
                                $scope.reqList.updateParams = postParams;
                                $scope.showReqList(null,null,null,false);
                            } else {
                                $scope.confirmUpdateRole(postParams);
                            }
                        }
                    //Existing flow for standard roles. Too complex to maintain and understand. :|
                    } else {
                        if ($scope.selectedRows && $scope.selectedRows.length) {
                            if ($scope.selectedRows.length == 1) {
                                postParams['userIds'].push($scope.selectedRows[0].EId);
                                if ($scope.selectedRows[0].roles) {
                                    for (var roleIndex in $scope.selectedRows[0].roles) {
                                        if ($scope.selectedRows[0].roles[roleIndex].key === 'ROLE_RECRUITER') {
                                            isRecruiter = true;
                                        }
                                        if ($scope.selectedRows[0].roles[roleIndex].key === 'ROLE_HIRING_MANAGER') {
                                            isHiringManager = true;
                                        }
                                    }
                                }
                            } else {
                                angular.forEach($scope.selectedRows, function(employee) {
                                    postParams['userIds'].push(employee.EId);
                                });
                            }
                        }

                        if ($scope.roleModal.rolesList && $scope.selectedRows) {
                            postParams['updateRole'] = [];
                            postParams['addRole'] = [];
                            angular.forEach($scope.roleModal.rolesList, function(role) {
                                if (role.checked) {
                                    if ($scope.selectedRows.length > 1) {
                                        postParams['addRole'].push(role.key);
                                    } else if ($scope.selectedRows.length == 1) {
                                        postParams['updateRole'].push(role.key);
                                    }
                                }
                            });
                            if (postParams['updateRole'] && (isRecruiter || isHiringManager)) {
                                for (var roleIndex in postParams['updateRole']) {
                                    if (postParams['updateRole'][roleIndex] === 'ROLE_HIRING_MANAGER') {
                                        isHiringManager = false;
                                    } else if (postParams['updateRole'][roleIndex] === 'ROLE_RECRUITER') {
                                        isRecruiter = false;
                                    }
                                }
                            }
                            if (isRecruiter) {
                                $scope.ownerIds.push($scope.selectedRows[0].EId);
                            }
                            if (isHiringManager) {
                                $scope.ownerIds.push($scope.selectedRows[0].EId);
                            }
                        }

                        if (isRecruiter || isHiringManager) {
                            $scope.reqList.showRoleUpdate = true;
                            $scope.reqList.showRemove = false;
                            $scope.reqList.updateParams = postParams;
                            $scope.showReqList(null,null,null,false);
                        } else {
                            $scope.confirmUpdateRole(postParams);
                        }
                    }
                };

                $scope.confirmUpdateRole = function(postParams) {
                    adminUserSVC.updateRoles(postParams, function(response,code){
                        $scope.flags.loading=false;
                        if(code === 'ATLEAST_ONE_ADMIN') {
                            $scope.roleModal.adminRoleError = true;
                        } else if(code === 'ATLEAST_ONE_HR') {
                            $scope.roleModal.hrRoleError = true;
                        } else if(code === 'RESEARCHER_LIMIT_REACHED') {
                            $scope.roleModal.error = true;
                        }
                        else if(code === 'SUCCESS') {
                            $scope.roleModal={};
                            if($scope.reqList && $scope.reqList.modal) {
                                $scope.reqList.modal.show=false;
                            }
                            $scope.searchEmployees(true);
                            $scope.showMsg('ROLES_UPDATED_SUCCESS');
                        }
                        else if(code === 'ERROR') {
                            $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                        }

                        if($scope.roleModal.hrRoleError || $scope.roleModal.adminRoleError || $scope.roleModal.error) {
                            if($scope.reqList && $scope.reqList.modal && $scope.reqList.modal.show) {
                                $scope.reqList.modal.show = false;
                                $scope.roleModal.show = true;
                            }
                        }
                    });
                };

                $scope.importFile = function(data) {
                	var sendInviteEmail = data.sendInviteEmail;
                    var fullSync = data.fullSync;
                    var resetSync = data.resetSync;
                    var considerExclusionList = data.considerExclusionList;
                    var key = data.uploadedFile.employeeSyncKey;
                    var fileName = data.uploadedFile.fileName;
                    var fileDelimiter = data.fileDelimiter;
                    $scope.fileName = data.uploadedFile.fileName;
                	adminUserSVC.import(key, fileName, sendInviteEmail, fullSync, resetSync, considerExclusionList, fileDelimiter, function(response){
                        if(response){
                		  $scope.flags.loading = false;
                		  $rootScope.$broadcast('showImportEmployeeConfirmation', response);
                        }else {
                            $scope.flags.loading = false;
                            $rootScope.$broadcast('showImportFailureModal', response);
                        }
                	});
                };

                var submitMapping = $rootScope.$on('submitMapping', function(event, data) {
                	$scope.flags.loading = true;
                	if(data && data.mapping.columnMappingId && data.mapping.columnMappingId.trim() !== "") {
                		adminUserSVC.updateMapping(data.mapping, function(response){
                			$scope.importFile(data);
                    	});
                	} else {
                		adminUserSVC.submit(data.mapping, function(response){
                    		$scope.importFile(data);
                    	});
                	}
                });

                var getMapping = $rootScope.$on('getMapping', function(event, data) {
                	adminUserSVC.getColumnMapping(data, function(response){
                		$rootScope.$broadcast('getMappingResponse', response);
                	});
                });

                var getSelects2Values = $rootScope.$on('getSelects2Values', function(event, data) {
                	adminUserSVC.getSelect2MappingValues(data, function(response){
                		$rootScope.$broadcast('getSelects2ValuesResponse', response);
                	});
                });
                /**
                * @doc function
                * @name $scope.validateInviteList
                * @description This method checks if a user has already accepted an invite . If so removes the user from the selectedRows array.
                * @param No Params
                * @see $scope.map.inviteStatuses for key value map of different invite status.
                * @returns true if there is atleast one user to whom invite needs to be sent. false is all the users selected have already accepted the invite
                **/

                $scope.validateInviteList = function(){
                    var userInviteList = [];
                    var userAcceptedInviteList =[];
                    angular.forEach($scope.selectedRows, function(user,key){
                        if($scope.map.inviteStatuses[user.invitationStatus.key] != 'INVITE_STATUS_ACCEPTED'){ // invitationStatus != Accepted
                            userInviteList.push(user);
                        }else{
                            userAcceptedInviteList.push(user);
                        }
                    });
                    $scope.totalInvite = $scope.selectedRows.length;
                    $scope.selectedRows = userInviteList;
                    $scope.invalidInvite = userAcceptedInviteList.length;

                    if(userInviteList.length > 0){
                        return true;
                    }
                    return false;
                };

                $scope.showMessage = function(messageType){
                    if($scope.selectedRows.length || messageType === 'inviteAll'){
                        $scope.flags.loading = true;
                        var _templateObject = {
                            name: messageType.toUpperCase()
                        };

                        switch(messageType) {
                            case 'invite':
                            case 'inviteAll':
                                _templateObject.title = i18n['SEND_INVITE'];
                                _templateObject.placeholder = i18n['MESSAGE_TO_EMPLOYEE'];
                                _templateObject.subjectPlaceholder = i18n['MESSAGE_TO_EMPLOYEE'] + ' ' +  i18n['DEFAULT_HEADER'];
                                $scope.messageModal = modalObjectTemplateFAC.get(_templateObject);

                                adminUserSVC.getInviteTemplates(function(response){
                                    if(response && response.inviteEmployeeTemplate) {
                                        $scope.messageModal.templates = $scope.select2Options.setTemplates(response.inviteEmployeeTemplate);
                                        angular.extend($scope.messageModal, modalObjectTemplateFAC.setDefault($scope.messageModal.templates));
                                    } else {
                                        $scope.messageModal.dontshowTemplate = true;
                                    }
                                    $scope.flags.loading = false;
                                });
                                break;
                            case 'note':
                                _templateObject.title = i18n['SEND_NOTE'];
                                _templateObject.placeholder = i18n['NOTE_TO_EMPLOYEE'];
                                _templateObject.subjectPlaceholder = i18n['NOTE_TO_EMPLOYEE'] + ' ' +  i18n['DEFAULT_HEADER'];
                                $scope.messageModal = modalObjectTemplateFAC.get(_templateObject);

                                adminUserSVC.getNoteTemplates(function(response){
                                    if(response && response.employeeNoteTemplate) {
                                        $scope.messageModal.dontshowTemplate = false;
                                        $scope.messageModal.templates = response.employeeNoteTemplate;
                                        angular.extend($scope.messageModal, modalObjectTemplateFAC.setDefault($scope.messageModal.templates));
                                    } else {
                                        $scope.messageModal.dontshowTemplate = true;
                                    }
                                    $scope.flags.loading = false;
                                });
                                break;
                            case 'message':
                                _templateObject.title = i18n['SEND_MESSAGE'];
                                _templateObject.placeholder = i18n['MESSAGE_TO_EMPLOYEE'];
                                _templateObject.subjectPlaceholder = i18n['MESSAGE_TO_EMPLOYEE'] + ' ' +  i18n['DEFAULT_HEADER'];
                                $scope.messageModal = modalObjectTemplateFAC.get(_templateObject);

                                adminUserSVC.getMessageTemplates(function(response){
                                    if(response && response.employeeMessageTemplate) {
                                        $scope.messageModal.templates = response.employeeMessageTemplate;
                                        angular.extend($scope.messageModal, modalObjectTemplateFAC.setDefault($scope.messageModal.templates));
                                    } else {
                                        $scope.messageModal.dontshowTemplate = true;
                                    }
                                    $scope.flags.loading = false;
                                });
                                break;
                        }
                    }
                };

                //Populating subject/body based on selected template
                $scope.$watch('messageModal.template',function(newVal, oldVal){
                    if(newVal){
                        angular.forEach($scope.messageModal.templates, function(templt){
                            if(templt.eid == newVal.eid){
                                $scope.messageModal.subject = templt.subject;
                                $scope.messageModal.body = templt.body;
                            }
                        });
                    }else{
                        $scope.messageModal.subject = '';
                        $scope.messageModal.body = '';
                    }
                },true);

                //Posting Message/Invite with params
                $scope.sendMessage = function(messageType){
                        $scope.flags.loading = true;
                        $scope.messageModal.checkdata = false;
                        if(!$scope.messageModal.subject|| ($scope.messageModal.subject && $scope.messageModal.subject.trim().length === 0))
                        {
                            $scope.messageModal.checkdata = true;
                            $scope.flags.loading=false;
                            return;
                        }
                        if(!$scope.messageModal.body|| ($scope.messageModal.body && $scope.messageModal.body.trim().length === 0))
                        {
                            $scope.messageModal.checkdata = true;
                            $scope.flags.loading = false;
                            return;
                        }
                    if(messageType === 'INVITE' || messageType === 'INVITEALL'){
                        var postParams = {};
                        if(messageType === 'INVITE') {
                            postParams['to'] = [];
                            angular.forEach($scope.selectedRows, function(employee){
                                postParams['to'].push(employee.EId);
                            });
                        }
                        postParams['subject'] = $scope.messageModal.subject;
                        postParams['content'] = $scope.messageModal.body;

                        /*BE expects locale to be sent to determine language for Email header/footer*/
                        if($scope.messageModal && $scope.messageModal.template){
                            postParams['locale'] = $scope.messageModal.template['locale'];
                        }
                        function onSuccess(response){
                            $scope.messageModal = {};
                            $scope.selectedEmployee = {};
                            $scope.showMsg('INVITE_SENT');
                            $scope.searchEmployees(true);
                        }
                        if(messageType === 'INVITE') {
                            adminUserSVC.sendEmployeeInvite(postParams,onSuccess);
                        } else {
                            adminUserSVC.sendInviteToAll(postParams, onSuccess);
                        }
                    }else if(messageType==='NOTE'){
                        var postParams = {};
                        postParams['to'] = [];
                        angular.forEach($scope.selectedRows, function(employee){
                            postParams['to'].push(employee.EId);
                        });
                        postParams['subject'] = $scope.messageModal.subject;
                        postParams['content'] = $scope.messageModal.body;
                        adminUserSVC.saveEmployeeNote(postParams, function(response){
                            $scope.messageModal = {};
                            $scope.selectedEmployee = {};
                            $scope.showMsg('NOTE_SENT');
                            $scope.searchEmployees(true);
                        });
                    }
                }

                $scope.showLocked = function(isLocked){
                    getSelectedEmployees();
                    if($scope.selectedRows.length){
                        $scope.$root.modal = {
                            show:true,
                            cancel: function(){$scope.$root.modal.show = false;},
                            buttons:[
                                        {label: isLocked ?i18n['LOCK']: i18n['UNLOCK'], title:isLocked ?i18n['LOCK']: i18n['UNLOCK'], click: function(){ $scope.lockRecords($scope.$root.modal.isLocked);}, 'class':'btn'},
                                        {label: i18n['CANCEL'], title:i18n['CANCEL'], click: function(){ $scope.$root.modal.show = false;}, 'class': 'btn cancel'}
                                    ],
                            title: isLocked ? i18n['LOCK_RECORDS']: i18n['UNLOCK_RECORDS'],
                            isLocked: isLocked,
                            body: i18n['SELECTED'] +' '
                        };
                        if(isLocked){
                            $scope.$root.modal.body += $scope.selectedRows.length==1
                                ? ($scope.selectedRows[0].firstName + ' ' +$scope.selectedRows[0].lastName + ' to add to the Locked Records list')
                                : ($scope.selectedRows.length + ' Employees to add to the Locked Records list');
                        }
                        else{
                            $scope.$root.modal.body +=  $scope.selectedRows.length==1
                                    ? ($scope.selectedRows[0].firstName + ' ' +$scope.selectedRows[0].lastName +' to add to the Unlocked Records list')
                                    : ($scope.selectedRows.length + ' Employees to add to the Unlocked Records list');
                        }
                    }
                };

                $scope.showRemove= function(){
                    getSelectedEmployees();
                    if($scope.selectedRows.length){
                        $scope.$root.modal={
                            show:true,
                            cancel: function(){$scope.$root.modal.show = false;},
                            buttons:[
                                        {label: i18n['REMOVE'], title:i18n['REMOVE'], click: function(){$scope.removeEmployee(true);}, 'class':'btn'},
                                        {label: i18n['CANCEL'], title:i18n['CANCEL'], click: function(){ $scope.$root.modal.show = false;}, 'class': 'btn cancel'}
                                    ],
                            title: i18n['REMOVE'] + ' ' + i18n['EMPLOYEES']
                        };
                        if($scope.selectedRows.length === 1) {
                            $scope.$root.modal.body = i18n["EMPLOYEE_REMOVE_CONFIRM"];
                        } else {
                            $scope.$root.modal.body = i18n["EMPLOYEES_REMOVE_CONFIRM"] + ' ' + $scope.selectedRows.length + ' ' + i18n['EMPLOYEES'] +'?';
                        }
                    }
                };

                $scope.setCheckAll = function() {
                   if($scope.employeeList) {
                       angular.forEach($scope.employeeList,function(employee,index) {
                           $scope.selectedEmployee[index] = $scope.checkAll;
                       });
                   }
                 };

                $scope.checkSelection = function() {
                    var checkList = true;
                    if(objectSize($scope.selectedEmployee) === $scope.employeeList.length) {
                        angular.forEach($scope.selectedEmployee, function(checkFlag) {
                           checkList &= checkFlag;
                        });
                    } else {
                        checkList = false;
                    }
                    $scope.checkAll = !!checkList;
                };

                $scope.showReqList = function(query, page, filter,isRemove) {
                    var data = {
                        page: page || 0,
                        q: query || '',
                        maxResults: $scope.modalFilters.maxModalResults || 10,
                        ownerIds: '',
                        mine: false,
                        jobStateValue: 1009,
                    };
                    var checkHiringManager=true;
                    var checkRecruiter=true;

                    angular.forEach($scope.roleModal.usrRoles, function(role) {
                        if(role.type === 'HiringManager'){
                            checkHiringManager = false;
                        }
                        if(role.type === 'Recruiter'){
                            checkRecruiter = false;
                        }
                    });
                    if(checkHiringManager && !checkRecruiter){
                       for (var roleIndex in $scope.selectedRows[0].roles) {
                            if($scope.selectedRows[0].roles[roleIndex].key === "ROLE_HIRING_MANAGER"){
                                data.hiringManagerIds = $scope.ownerIds.join(',');
                            }
                        }
                    }
                    if(checkRecruiter && !checkHiringManager){
                       for (var roleIndex in $scope.selectedRows[0].roles) {
                            if($scope.selectedRows[0].roles[roleIndex].key === "ROLE_RECRUITER"){
                                data.recruiterIds = $scope.ownerIds.join(',');
                            }
                        }
                    }
                    if($scope.ownerIds) {
                        data.ownerIds = $scope.ownerIds.join(',');
                    }
                    adminUserSVC.getReqsList($.param(data),function(res,code) {
                        if(code === 200){
                            $scope.reqList.response = res;
                            $scope.pageSize = 10;
                            if($scope.reqList.response.jobs.length){
                                $scope.roleModal.show = false;
                                $scope.reqList.modal = {
                                    show: true,
                                    title: i18n['ACTIVE_REQ_IMPACT'],
                                    page: page,
                                    queryData: data,
                                    query: query
                                };
                                $scope.totalCount = res.jobCount || 0;
                                $scope.reqList.modal.header = isRemove ? (i18n['REMOVE'] + ' ' + i18n['EMPLOYEES']) : i18n['UPDATE_ROLE'];
                            }else{
                                if(isRemove){
                                    $scope.removeUsers($scope.reqList.updateParams);
                                }else{
                                    $scope.confirmUpdateRole($scope.reqList.updateParams);
                                }
                            }
                        }
                        $scope.flags.loading = false;
                    });
                };
                $scope.change = function(modal,id){
                    getSelectedEmployees();
                    if($scope.selectedRows.length){
                        switch(modal){
                            case 0:
                                //Before sending invite we check if user has accepted invite
                                if($scope.validateInviteList()){
                                    $scope.showMessage('invite');
                                }else{
                                    //Employee already accepted invite
                                    $scope.$root.modal = {
                                        show:true,
                                        buttons:[
                                            {
                                                label: i18n['CLOSE'],
                                                title:i18n['CLOSE'],
                                                click: function(){
                                                    $scope.$root.modal.show = false;
                                                }
                                            }
                                        ],
                                        title: i18n['SEND_INVITE'],
                                        body: i18n['EMP_ALREADY_ACCEPTED_INVIE'],
                                        cancel: function(){
                                            $scope.$root.modal.show = false;
                                        }
                                    };
                                }
                                break;
                            case 1:
                                $scope.showMessage('note');
                                break;
                            case 2:
                                $scope.showLocked(true);
                                break;
                            case 3:
                                $scope.showLocked(false);
                                break;
                            case 4:
                                $scope.showUpdateRoles();
                                break;
                            case 5:
                                $scope.showRemove();
                                break;
                            }
                    }
                    else{
                        return -1;
                    }
                };

                $scope.lockRecords = function(isLocked){
                    $scope.flags.loading = true;
                    var postParams = {};
                    postParams['lock'] = isLocked;
                    postParams['userIds'] = [];
                    angular.forEach($scope.selectedRows, function(employee){
                        postParams['userIds'].push(employee.EId);
                    });
                    adminUserSVC.lockRecords(postParams, function(response){
                        $scope.$root.modal = {};
                        $scope.selectedEmployee = {};
                        if(isLocked)
                            $scope.showMsg('LOCKED_EMPLOYEES');
                        else
                            $scope.showMsg('UNLOCKED_EMPLOYEES');
                        $scope.searchEmployees(true);
                    });
                    $scope.flags.loading = false;
                };

                $scope.removeEmployee = function(showList){
                    $scope.flags.loading = true;
                    $scope.reqList.updateParams={};
                    var callReqList = false;
                    var postParams = {};
                    $scope.ownerIds = [];
                    postParams['remove'] = true;
                    postParams['userIds'] = [];

                    angular.forEach($scope.selectedRows, function(employee){
                        postParams['userIds'].push(employee.EId);
                        if(employee.roles){
                            for(var roleIndex in employee.roles){
                                if(employee.roles[roleIndex].key == 262144){
                                    $scope.ownerIds.push(employee.EId);
                                    callReqList=true;
                                }
                                if(employee.roles[roleIndex].key==4){
                                    $scope.ownerIds.push(employee.EId);
                                    callReqList=true;
                                }
                            }
                        }
                    });
                    if(showList && callReqList) {
                        $scope.$root.modal = {};
                        $scope.reqList.showRemove = true;
                        $scope.reqList.showRoleUpdate = false;
                        $scope.reqList.updateParams = postParams;
                        $scope.showReqList(null,null,null,true);
                    } else {
                        $scope.removeUsers(postParams);
                    }
                };

                $scope.removeUsers = function(postParams) {
                    if( angular.isUndefined(postParams)) {
                        postParams = angular.copy($scope.ownerIds);
                    }
                    adminUserSVC.removeEmployee(postParams, function(response) {
                        if(response){
                            if(response.msgInfo === 200){
                                $scope.selectedEmployee = {};
                                $scope.showMsg('EMPLOYEE_REMOVED');
                                if($scope.reqList && $scope.reqList.modal){
                                    $scope.reqList.modal.show=false;
                                }
                                $scope.$root.modal = {};
                                $scope.searchEmployees(true);
                            }
                            else if(response.msgInfo === 400){
                                $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                            }
                        }
                        $scope.flags.loading = false;
                    });
                };

                $scope.cascadeRoleSelect = function(role) {
                    //clearing error if shown any once user selects role
                    if($scope.roleModal) {
                        $scope.roleModal.error = false;
                        $scope.roleModal.adminRoleError = false;
                        $scope.roleModal.hrRoleError = false;
                    }
                 };
                
                 $scope.$on('$destroy', function() {
                	 refreshListPage();
                	 importedEmployeeSyncFile();
                	 submitMapping();
                	 getMapping();
                	 getSelects2Values();
                 });
            }
        
    ]);
